<template>
  <div
    @click="navigateTo"
    class="shadow-box rounded-xl bg-white w-full eventhover"
    :id="`event-post-${layout}-${event.id}`"
  >
    <div class="flex p-3 gap-3" :id="`event-post-${layout}-${event.id}`">
      <div
        class="flex-none rounded-xl overflow-hidden h-24 w-24 2xs:h-28 2xs:w-28"
      >
        <img
          :src="`${$APP_CONFIG.BASE_IMAGE_URL}${event.image1}`"
          class="h-full w-full object-cover"
          alt=""
        />
      </div>
      <div class="flex-grow">
        <div class="flex w-full">
          <div class="flex-grow">
            <!-- <div class="text-green-800 font-medium  md:w-56 sm:w-48 2xs:w-40 w-32 truncate  " >{{ event.title }}</div> -->
            <div
              class="
                text-green-800
                font-medium
                2xl:w-56
                xl:w-48
                md:w-36
                sm:w-44
                2xs:w-40
                w-32
                truncate
              "
            >
              {{ event.title }}
            </div>
          </div>
          <div class="flex-none relative">
            <div @click="toggleval($event, event.updatedAt)">
              <img
                src="/img/myle/svg/more.svg"
                :class="`h-4 w-4 cursor-pointer m-1 ${event.eventCode}`"
                id="more-options"
                alt=""
              />
            </div>
            <div
              class="
                bg-white
                w-20
                rounded
                p-2
                absolute
                right-2
                top-1
                shadow-box
                flex-col
              "
              v-bind:class="{ hidden: !this.toggleDataid[event.updatedAt] }"
              :id="event.updatedAt"
            >
              <div
                v-if="!event.isExpired"
                id="more-options"
                class="
                text-gray-500
                p-1
                text-sm
                cursor-pointer
                hover:text-green-800
                truncate
              "
                @click="
                  preview($event, event.eventCode, event, event.updatedAt)
                "
              >
                Preview
              </div>
              <div
                id="more-options"
                class="
                  text-gray-500
                  p-1
                  text-sm
                  cursor-pointer
                  hover:text-green-800
                  truncate
                "
                @click="toggleval($event, event.updatedAt, event)"
              >
                Share
              </div>
            </div>
          </div>
        </div>
        <p class="text-sm 2xs:pt-1 flex text-gray-400">
          <span
            ><img
              class="mt-1 mr-1 h-2.5"
              src="/img/myle/svg/tag.svg"
              alt="price tag"
          /></span>
          <span class=""
            ><template
              v-if="
                event.havePrice && (event.minimumPrice || event.maximumPrice)
              "
            >
              {{
                event.minimumPrice == '9999' && event.maximumPrice == '9999'
                  ? 'VARIES'
                  : '$' + event.minimumPrice + '-' + event.maximumPrice
              }}</template
            ><template v-else>
              FREE</template
            ></span
          >
        </p>
        <p class="text-gray-400 text-sm 2xs:pt-1">
          <span class="mr-1"
            ><i
              class="fas fa-calendar text-gray-400 text-xs"
              aria-hidden="true"
            ></i
          ></span>
          <span>{{ offsetDiff(event) }}</span>

          <span>{{ '(' + getZoneName + ')' }}</span>
        </p>
        <div class="mt-1 2xs:mt-2">
          <a
            class="
              rounded-full
              text-green-800
              cursor-default
              text-sm
              bg-gray-300
              py-1
              px-3
              w-max
            "
            >{{ status }}</a
          >
        </div>
      </div>
    </div>
    <event-stats
      :event="event"
      :attendingEvents="attendingEvents"
      :lovedEvents="lovedEvents"
      :likedEvents="likedEvents"
      :authenticated="true"
      :highlightattend="highlightattend"
      :highlightlike="highlightlike"
      :highlightlove="highlightlove"
    ></event-stats>
  </div>
</template>
<script>
import categoryHelper from '@/helpers/category-helper.js';
import EventStats from '../components/EventStats';
import { mapMutations } from 'vuex';

import { userService } from '../services/user.service';
import { computed } from 'vue2-dropzone';
import { formatDaylightOffsetSuffix } from '../config/time';

export default {
  name: 'event-post',
  components: {
    EventStats,
  },
  props: {
    attendingEvents: {
      type: Boolean,
      default: false,
    },
    lovedEvents: {
      type: Boolean,
      default: false,
    },
    likedEvents: {
      type: Boolean,
      default: false,
    },
    event: {
      type: Object,
      default: {},
    },
    extraClass: {
      type: String,
      default: '',
    },
    layout: {
      type: String,
      default: 'tablet',
    },
    highlightattend: {
      type: Boolean,
      default: false,
    },
    highlightlove: {
      type: Boolean,
      default: false,
    },
    highlightlike: {
      type: Boolean,
      default: false,
    },
    categories: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {
      showModel: false,
      selectedEventCode: null,
      currentEvent: null,
      status: '',
      toggleDataid: {},
      images: [
        'travel.jpg',
        'theatre.jpg',
        'artsandculture.jpg',
        'familyfun.jpg',
        'health.jpg',
        'outdoors.jpg',
        'nightlife.jpg',
        'misc.jpg',
      ],
    };
  },
  computed: {
    getZoneName() {
      const d = new Date();
      d.setDate(15);
      d.setMonth(0);
      return d
        .toLocaleDateString('en-us', { day: '2-digit', timeZoneName: 'long' })
        .substring(4)
        .match(/\b(\w)/g)
        .join('');
    },
  },
  methods: {
    ...mapMutations('events', ['updateSubModel']),
    getCatNames(ids) {
      return categoryHelper.getCategoryNamesByIds(this.categories, ids);
    },
    preview: function(e, e1, e2, evt) {
      e.preventDefault();
      e.stopPropagation();
      const routeData = this.$router.resolve({
        name: 'e',
        params: {
          title: e2.title,
          id: e2.eventCode,
        },
      });
      window.open(routeData.href, '_blank');

      this.currentEvent = evt;

      this.toggleDataid[evt] = !this.toggleDataid[evt];
      this.toggleDataid = { ...this.toggleDataid };

      const vv = document.getElementsByClassName(
        'bg-white w-20 rounded p-2 absolute right-2 top-1 shadow-box flex-col'
      );
      if (vv.length) {
        for (var ele = 0; ele < vv.length; ele++) {
          if (vv[ele].id != evt && !vv[ele].classList.contains('hidden')) {
            vv[ele].classList.toggle('hidden');
          }
        }
      }
    },
    offsetDiff1(dt) {
      const m = this.$moment(dt);
      const year = m.isValid() ? m.year() : new Date().getFullYear();
      const zz = formatDaylightOffsetSuffix(year);
      return this.$moment(dt)
        .add(0, 'hours')
        .utcOffset(zz)
        .format('MMM DD, YYYY | hh:mm A');
    },
    offsetDiff(ev) {
      const dt = ev.startDateTime;
      let hrv = userService.fixHours(dt, this.$moment().isDST()).hrv;
      let mins = userService.fixHours(dt, this.$moment().isDST()).mins;
      return this.$moment(dt)
        .local()
        .add(hrv, 'hours')
        .add(mins, 'minutes')
        .format('MMM DD, YYYY | hh:mm A');
    },
    getRandomImage() {
      return this.images[Math.floor(Math.random() * this.images.length)];
    },
    toggleval(e, evt, evnt) {
      this.currentEvent = evt;
      e.stopPropagation();
      if (evnt) {
        navigator.clipboard.writeText(
          'https://web.myle.com/eid/' + evnt.eventCode
        );
        this.$toast.success('Link copied. Paste to share.', { timeout: 4000 });
      }
      this.toggleDataid[evt] = !this.toggleDataid[evt];
      this.toggleDataid = { ...this.toggleDataid };

      const vv = document.getElementsByClassName(
        'bg-white w-20 rounded p-2 absolute right-2 top-1 shadow-box flex-col'
      );
      if (vv.length) {
        for (var ele = 0; ele < vv.length; ele++) {
          if (vv[ele].id != evt && !vv[ele].classList.contains('hidden')) {
            vv[ele].classList.toggle('hidden');
          }
        }
      }
    },
    navigateTo(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$router.push({
        name: 'e',
        params: {
          title: this.event.title,
          id: this.event.eventCode,
        },
      });
    },
  },
  mounted() {
    if (this.event.isRecurring) {
      if (new Date().getTime() < new Date(this.event.startDateTime).getTime()) {
        this.status = 'UPCOMING';
      } else {
        this.status = 'RECURRING';
      }
    } else {
      if (new Date().getTime() < new Date(this.event.startDateTime).getTime()) {
        this.status = 'UPCOMING';
      } else {
        this.status = 'ON-GOING';
      }
    }
    this.toggleDataid = {};
    window.onclick = (ev) => {
      const v = ev.target.classList[ev.target.classList.length - 1];
      const vv = document.getElementsByClassName(
        'bg-white w-20 rounded p-2 absolute right-2 top-1 shadow-box flex-col'
      );
      if (vv.length) {
        for (var ele = 0; ele < vv.length; ele++) {
          if (!vv[ele].classList.contains('hidden')) {
            vv[ele].classList.toggle('hidden');
          }
        }
      }

      const e = document.getElementById(v);

      if (e) {
        e.classList.toggle('hidden');
      }
    };
  },
};
</script>
<style scoped>
.shadow-box.rounded-xl.bg-white.w-full.eventhover:hover {
  -webkit-box-shadow: 0 0 7px 0 rgb(170 207 56 / 90%);
  box-shadow: 0 0 7px 0 rgb(170 207 56 / 90%);
  cursor: pointer !important;
}
</style>
